import { render, staticRenderFns } from "./ResetEmailForm.vue?vue&type=template&id=bf1d3270"
import script from "./ResetEmailForm.vue?vue&type=script&lang=js"
export * from "./ResetEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports